<template>
  <div
    class="flex items-center gap-3 rounded-lg border p-4"
    :class="{
      'bg-yapgray-200 dark:border-yapdarkgray-800 dark:bg-yapdarkgray-950': style === InfoStyle.Info || !style,
      'border-green-200 bg-green-50 dark:border-green-900 dark:bg-green-950': style === InfoStyle.Success,
      'border-yapmorange-200 bg-yapmorange-50 dark:border-orange-800 dark:bg-orange-950': style === InfoStyle.Warning,
      'border-red-700 bg-red-300 text-red-900 dark:border-red-900 dark:bg-red-950': style === InfoStyle.Danger
    }"
  >
    <YapIcon
      :name="localIcon"
      class="h-6 w-6 shrink-0"
      :class="{
        'text-primary-500 dark:text-primary-dark-400': style === InfoStyle.Info || !style,
        'text-green-600 dark:text-green-500': style === InfoStyle.Success,
        'text-yapmorange-600 dark:text-yapmorange-500': style === InfoStyle.Warning,
        'text-red-900 dark:text-red-600': style === InfoStyle.Danger
      }"
    />
    <div>
      <h4
        v-if="title"
        class="text-xl"
        :class="{
          'text-primary-950 dark:text-primary-dark-100': style === InfoStyle.Info || !style,
          'text-green-950 dark:text-green-100': style === InfoStyle.Success,
          'text-orange-950 dark:text-orange-100': style === InfoStyle.Warning,
          'text-red-950 dark:text-red-100': style === InfoStyle.Danger
        }"
      >
        {{ title }}
      </h4>
      <p
        v-if="messageIsMd"
        class="prose text-sm text-yapgray-600 dark:prose-invert dark:text-yapgray-100"
        v-html="message"
      />
      <p
        v-else
        class="text-sm"
        :class="{
          'text-yapgray-800 dark:text-primary-dark-100': style === InfoStyle.Info || !style,
          'text-green-900 dark:text-green-300': style === InfoStyle.Success,
          'text-orange-900 dark:text-orange-300': style === InfoStyle.Warning,
          'text-red-900 dark:text-red-300': style === InfoStyle.Danger
        }"
      >
        {{ message }}
      </p>
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { InfoStyle } from '@/types/yapInfo';
import YapIcon from '@/components/YapIcon.vue';

const props = defineProps<{
  icon?: string;
  title?: string;
  message: string;
  messageIsMd?: boolean;
  style?: InfoStyle;
}>();

const localIcon = computed(() => {
  if (props.icon) return props.icon;

  switch (props.style) {
    case InfoStyle.Info:
      return 'information-circle';
    case InfoStyle.Success:
      return 'checkmark-circle-outline';
    case InfoStyle.Warning:
      // return 'exclamation-triangle';
      return 'exclamation-circle';
    case InfoStyle.Danger:
      // return 'stop-outline';
      // return 'exclamation-circle';
      return 'exclamation-triangle';

    default:
      return 'information-circle';
  }
});
</script>
